var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Vigenère-Chiffre")]),_c('h2',[_vm._v("Verschlüsselung")]),_c('Vigenere',{attrs:{"mode":"encrypt"}}),_c('h2',[_vm._v("Entschlüsselung")]),_c('Vigenere',{attrs:{"mode":"decrypt"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }